import { render } from "./MobileMenuItem.vue?vue&type=template&id=2118953d&scoped=true&ts=true"
import script from "./MobileMenuItem.vue?vue&type=script&lang=ts"
export * from "./MobileMenuItem.vue?vue&type=script&lang=ts"

import "./MobileMenuItem.vue?vue&type=style&index=0&id=2118953d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2118953d"]])

export default __exports__